export enum PageType {
    Full = 0,
    Partial = 1,
    Component = 2,
}